import clsx from "clsx";

export const NoticeItem = ({
  title,
  notices,
}: {
  title: string;
  notices: string[];
}) => {
  return (
    <li className="space-y-[6px]">
      <section
        className={clsx([
          "ml-[10px] font-bold [counter-increment:list-number]",
          "before:relative before:left-[-10px] before:inline-block before:h-[10px] before:w-[10px] before:font-bold before:content-[counter(list-number)]",
        ])}
      >
        {title}
      </section>
      <ul className="ml-[24px] space-y-[6px]">
        {notices.map((notice, i) => (
          <li
            key={i}
            className={clsx([
              "pl-[14px] indent-[-10px] leading-[160%]",
              "before:relative before:top-px before:left-[-8px] before:inline-block before:h-[10px] before:w-[10px] before:bg-black before:content-['']",
            ])}
          >
            {notice}
          </li>
        ))}
      </ul>
    </li>
  );
};
